import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=5c1f7dc5&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"
import style1 from "./Payments.vue?vue&type=style&index=1&id=5c1f7dc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f7dc5",
  null
  
)

export default component.exports